export const CSM_WIDGET_POST_MESSAGE_NAMESPACE = 'CSM_WIDGET' as const;
